import { useState, useEffect, useCallback } from 'react';
import api from '../api/client';

export default function AbandonedCarts() {
  const [carts, setCarts] = useState([]);
  const [filter, setFilter] = useState('');

  const fetchCarts = useCallback(() => {
    const query = filter ? `?estado=${filter}` : '';
    api.get(`/abandoned-carts${query}`).then((res) => setCarts(res.data.carts));
  }, [filter]);

  useEffect(() => { fetchCarts(); }, [fetchCarts]);

  const handleNotify = async (id) => {
    try {
      await api.post(`/abandoned-carts/${id}/notify`);
      alert('Recordatorio enviado');
      fetchCarts();
    } catch (err) {
      alert(err.response?.data?.error || 'Error al enviar');
    }
  };

  const estadoColor = { pendiente: '#f39c12', notificado: '#3498db', recuperado: '#2ecc71' };

  return (
    <div>
      <h1>Carritos abandonados</h1>

      <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
        {['', 'pendiente', 'notificado', 'recuperado'].map((f) => (
          <button key={f} onClick={() => setFilter(f)} style={{
            padding: '6px 16px', borderRadius: 20, border: '1px solid #ddd',
            background: filter === f ? '#1a1a2e' : '#fff', color: filter === f ? '#fff' : '#333',
            cursor: 'pointer', fontSize: 13,
          }}>{f || 'Todos'}</button>
        ))}
      </div>

      <div style={{ background: '#fff', borderRadius: 8, overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ borderBottom: '2px solid #eee', textAlign: 'left' }}>
              <th style={{ padding: 12 }}>Contacto</th>
              <th>Total</th>
              <th>Productos</th>
              <th>Estado</th>
              <th>Fecha</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {carts.map((c) => (
              <tr key={c.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                <td style={{ padding: 12 }}>{c.Contact?.nombre || 'Sin contacto'}<br/><small style={{color:'#888'}}>{c.Contact?.telefono}</small></td>
                <td>${Number(c.total).toLocaleString()} {c.currency}</td>
                <td>{Array.isArray(c.productos) ? c.productos.length : '-'} items</td>
                <td>
                  <span style={{
                    padding: '3px 10px', borderRadius: 12, fontSize: 11,
                    background: `${estadoColor[c.estado]}20`, color: estadoColor[c.estado],
                  }}>{c.estado}</span>
                </td>
                <td>{new Date(c.createdAt).toLocaleString()}</td>
                <td>
                  {c.estado === 'pendiente' && c.Contact && (
                    <button onClick={() => handleNotify(c.id)} style={{
                      padding: '4px 12px', background: '#4ecca3', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12,
                    }}>Enviar recordatorio</button>
                  )}
                </td>
              </tr>
            ))}
            {carts.length === 0 && (
              <tr><td colSpan={6} style={{ padding: 30, textAlign: 'center', color: '#888' }}>No hay carritos abandonados</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
